export enum VerktoyInfoState {
  IkkeTilgjengelig,
  ManglendeTilgang,
  DuMaaLoggePaa,
  MaaForskrives,
}
